// src/services/emailVerificationService.js
import { collection, addDoc, doc, getDoc, setDoc, updateDoc, serverTimestamp, query, where, getDocs, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';

const mailCollection = collection(db, 'mail');
const verificationCollection = collection(db, 'EmailVerifications');

// Doğrulama kodu süresi (dakika)
const VERIFICATION_CODE_EXPIRY = 10;
const MAX_ATTEMPTS = 5;

/**
 * 6 haneli doğrulama kodu oluştur
 */
const generateVerificationCode = () => {
  return Math.floor(100000 + Math.random() * 900000).toString();
};

/**
 * Token oluştur
 */
const generateToken = () => {
  return `${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
};

/**
 * E-posta doğrulama HTML şablonu
 */
const getVerificationEmailTemplate = (code, name) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
        body {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
          line-height: 1.6;
          color: #333;
          background-color: #f4f4f4;
          margin: 0;
          padding: 0;
        }
        .container {
          max-width: 600px;
          margin: 40px auto;
          background: white;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        }
        .header {
          background: linear-gradient(135deg, #E5332A 0%, #c72a22 100%);
          padding: 40px 30px;
          text-align: center;
          color: white;
        }
        .header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 800;
        }
        .content {
          padding: 40px 30px;
        }
        .greeting {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 20px;
          color: #2B2B2B;
        }
        .message {
          font-size: 15px;
          color: #495057;
          margin-bottom: 30px;
          line-height: 1.8;
        }
        .code-container {
          background: #f8f9fa;
          border: 2px dashed #dee2e6;
          border-radius: 12px;
          padding: 30px;
          text-align: center;
          margin: 30px 0;
        }
        .code-label {
          font-size: 13px;
          color: #868e96;
          margin-bottom: 10px;
          text-transform: uppercase;
          letter-spacing: 1px;
          font-weight: 600;
        }
        .code {
          font-size: 42px;
          font-weight: 800;
          color: #E5332A;
          letter-spacing: 8px;
          font-family: 'Courier New', monospace;
          margin: 10px 0;
          user-select: all;
        }
        .code-validity {
          font-size: 13px;
          color: #dc3545;
          margin-top: 15px;
          font-weight: 600;
        }
        .warning {
          background: #fff3cd;
          border-left: 4px solid #ffc107;
          padding: 15px 20px;
          margin: 25px 0;
          border-radius: 4px;
        }
        .warning-title {
          font-weight: 700;
          color: #856404;
          margin-bottom: 5px;
          font-size: 14px;
        }
        .warning-text {
          font-size: 13px;
          color: #856404;
          line-height: 1.6;
        }
        .footer {
          background: #f8f9fa;
          padding: 30px;
          text-align: center;
          font-size: 13px;
          color: #868e96;
          border-top: 1px solid #dee2e6;
        }
        .footer-brand {
          font-weight: 700;
          color: #E5332A;
          margin-bottom: 10px;
          font-size: 16px;
        }
        @media only screen and (max-width: 600px) {
          .container {
            margin: 20px;
            border-radius: 8px;
          }
          .header {
            padding: 30px 20px;
          }
          .header h1 {
            font-size: 24px;
          }
          .content {
            padding: 30px 20px;
          }
          .code {
            font-size: 36px;
            letter-spacing: 6px;
          }
          .code-container {
            padding: 20px;
          }
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>🔐 E-posta Doğrulama</h1>
        </div>
        
        <div class="content">
          <div class="greeting">
            Merhaba ${name},
          </div>
          
          <div class="message">
            Trona'ya hoş geldiniz! Kayıt işleminizi tamamlamak için aşağıdaki 6 haneli doğrulama kodunu kullanın.
          </div>
          
          <div class="code-container">
            <div class="code-label">Doğrulama Kodunuz</div>
            <div class="code">${code}</div>
            <div class="code-validity">⏱️ Bu kod ${VERIFICATION_CODE_EXPIRY} dakika geçerlidir</div>
          </div>
          
          <div class="message">
            Bu kodu kayıt sayfasında ilgili alana girerek hesabınızı doğrulayabilirsiniz.
          </div>
          
          <div class="warning">
            <div class="warning-title">⚠️ Güvenlik Uyarısı</div>
            <div class="warning-text">
              • Bu kodu kimseyle paylaşmayın<br>
              • Trona çalışanları asla bu kodu sormaz<br>
              • Şüpheli bir durum varsa hemen bize bildirin
            </div>
          </div>
          
          <div class="message" style="font-size: 13px; color: #868e96; margin-top: 30px;">
            Eğer bu işlemi siz yapmadıysanız, bu e-postayı güvenle görmezden gelebilirsiniz.
          </div>
        </div>
        
        <div class="footer">
          <div class="footer-brand">TRONA PAZARLAMA</div>
          <div>Güvenli alışverişin adresi</div>
          
          <div style="margin-top: 20px; font-size: 12px;">
            © ${new Date().getFullYear()} Trona Pazarlama. Tüm hakları saklıdır.<br>
            Bu e-posta otomatik olarak gönderilmiştir, lütfen yanıtlamayın.
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};

/**
 * Doğrulama kodu e-postası gönder
 */
const sendVerificationEmail = async (to, code, name) => {
  try {
    await addDoc(mailCollection, {
      to: to,
      message: {
        subject: `${code} - Trona E-posta Doğrulama Kodu`,
        html: getVerificationEmailTemplate(code, name),
        text: `Merhaba ${name}, Trona kayıt doğrulama kodunuz: ${code}. Bu kod ${VERIFICATION_CODE_EXPIRY} dakika geçerlidir.`
      },
      createdAt: serverTimestamp()
    });
    
    console.log('✅ Doğrulama e-postası kuyruğa eklendi:', to);
    return { success: true };
  } catch (error) {
    console.error('❌ E-posta gönderme hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Yeni doğrulama kodu oluştur ve gönder
 */
export const createVerificationCode = async (email, name, password) => {
  try {
    // E-posta formatı kontrolü
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return {
        success: false,
        message: 'Geçersiz e-posta formatı'
      };
    }

    // Kullanıcı zaten var mı kontrol et (Firebase Auth)
    // Bu kontrol AuthPage'de yapılıyor, burada tekrar yapılabilir

    // Kod ve token oluştur
    const verificationCode = generateVerificationCode();
    const token = generateToken();

    // Doğrulama kaydı oluştur
    const expiresAt = new Date(Date.now() + VERIFICATION_CODE_EXPIRY * 60 * 1000);
    
    await setDoc(doc(verificationCollection, token), {
      email,
      name,
      password, // Güvenlik notu: Gerçek uygulamada şifreyi hash'leyerek saklayın veya hiç saklamayın
      code: verificationCode,
      token,
      createdAt: serverTimestamp(),
      expiresAt: expiresAt,
      attempts: 0,
      verified: false,
      lastAttempt: null
    });

    // E-posta gönder
    const emailResult = await sendVerificationEmail(email, verificationCode, name);

    if (!emailResult.success) {
      // E-posta gönderilemezse kaydı sil
      await deleteDoc(doc(verificationCollection, token));
      return {
        success: false,
        message: 'E-posta gönderilemedi. Lütfen tekrar deneyin.'
      };
    }

    console.log(`✅ Doğrulama kodu oluşturuldu: ${email} - Token: ${token}`);

    return {
      success: true,
      token: token,
      message: 'Doğrulama kodu gönderildi'
    };

  } catch (error) {
    console.error('Doğrulama kodu oluşturma hatası:', error);
    return {
      success: false,
      message: 'Bir hata oluştu. Lütfen tekrar deneyin.',
      error: error.message
    };
  }
};

/**
 * Doğrulama kodunu kontrol et
 */
export const verifyCode = async (token, code) => {
  try {
    if (!token || !code) {
      return {
        success: false,
        message: 'Token ve kod gerekli'
      };
    }

    // Kod 6 haneli mi?
    if (code.length !== 6 || !/^\d+$/.test(code)) {
      return {
        success: false,
        message: 'Geçersiz kod formatı'
      };
    }

    // Doğrulama kaydını getir
    const verificationRef = doc(verificationCollection, token);
    const verificationSnap = await getDoc(verificationRef);

    if (!verificationSnap.exists()) {
      return {
        success: false,
        message: 'Geçersiz veya süresi dolmuş token'
      };
    }

    const verificationData = verificationSnap.data();

    // Zaten doğrulanmış mı?
    if (verificationData.verified) {
      return {
        success: false,
        message: 'Bu kod zaten kullanıldı'
      };
    }

    // Süre dolmuş mu?
    const now = new Date();
    const expiresAt = verificationData.expiresAt.toDate();
    
    if (expiresAt < now) {
      return {
        success: false,
        message: 'Kodun süresi doldu. Lütfen yeni kod isteyin',
        expired: true
      };
    }

    // Çok fazla deneme yapılmış mı?
    if (verificationData.attempts >= MAX_ATTEMPTS) {
      return {
        success: false,
        message: 'Çok fazla yanlış deneme. Lütfen yeni kod isteyin',
        tooManyAttempts: true
      };
    }

    // Kod doğru mu?
    if (verificationData.code !== code) {
      // Hatalı deneme sayısını artır
      await updateDoc(verificationRef, {
        attempts: verificationData.attempts + 1,
        lastAttempt: serverTimestamp()
      });

      const remainingAttempts = MAX_ATTEMPTS - (verificationData.attempts + 1);
      
      return {
        success: false,
        message: `Geçersiz doğrulama kodu. ${remainingAttempts} deneme hakkınız kaldı.`,
        remainingAttempts: remainingAttempts
      };
    }

    // Kod doğru! Verified olarak işaretle
    await updateDoc(verificationRef, {
      verified: true,
      verifiedAt: serverTimestamp()
    });

    console.log(`✅ E-posta doğrulandı: ${verificationData.email}`);

    return {
      success: true,
      message: 'E-posta başarıyla doğrulandı',
      email: verificationData.email,
      name: verificationData.name,
      password: verificationData.password
    };

  } catch (error) {
    console.error('Kod doğrulama hatası:', error);
    return {
      success: false,
      message: 'Doğrulama sırasında hata oluştu',
      error: error.message
    };
  }
};

/**
 * Doğrulama kodunu yeniden gönder
 */
export const resendVerificationCode = async (token) => {
  try {
    if (!token) {
      return {
        success: false,
        message: 'Token gerekli'
      };
    }

    // Doğrulama kaydını getir
    const verificationRef = doc(verificationCollection, token);
    const verificationSnap = await getDoc(verificationRef);

    if (!verificationSnap.exists()) {
      return {
        success: false,
        message: 'Geçersiz token'
      };
    }

    const verificationData = verificationSnap.data();

    // Zaten doğrulanmış mı?
    if (verificationData.verified) {
      return {
        success: false,
        message: 'E-posta zaten doğrulanmış'
      };
    }

    // Yeni kod oluştur
    const newCode = generateVerificationCode();
    const newExpiresAt = new Date(Date.now() + VERIFICATION_CODE_EXPIRY * 60 * 1000);

    // Güncelle
    await updateDoc(verificationRef, {
      code: newCode,
      expiresAt: newExpiresAt,
      attempts: 0, // Deneme sayısını sıfırla
      updatedAt: serverTimestamp()
    });

    // Yeni e-posta gönder
    const emailResult = await sendVerificationEmail(
      verificationData.email,
      newCode,
      verificationData.name
    );

    if (!emailResult.success) {
      return {
        success: false,
        message: 'E-posta gönderilemedi'
      };
    }

    console.log(`✅ Doğrulama kodu yeniden gönderildi: ${verificationData.email}`);

    return {
      success: true,
      message: 'Yeni doğrulama kodu gönderildi'
    };

  } catch (error) {
    console.error('Kod yeniden gönderme hatası:', error);
    return {
      success: false,
      message: 'Kod gönderilemedi',
      error: error.message
    };
  }
};

/**
 * Süresi dolmuş doğrulama kayıtlarını temizle (Admin/Maintenance)
 */
export const cleanupExpiredVerifications = async () => {
  try {
    const now = new Date();
    
    // Süresi dolmuş ve doğrulanmamış kayıtları getir
    const q = query(
      verificationCollection,
      where('verified', '==', false)
    );
    
    const snapshot = await getDocs(q);
    let deletedCount = 0;

    for (const docSnap of snapshot.docs) {
      const data = docSnap.data();
      const expiresAt = data.expiresAt.toDate();
      
      // 1 saatten eski kayıtları sil
      if (expiresAt < new Date(now.getTime() - 60 * 60 * 1000)) {
        await deleteDoc(docSnap.ref);
        deletedCount++;
      }
    }

    console.log(`✅ ${deletedCount} süresi dolmuş doğrulama kaydı temizlendi`);
    
    return {
      success: true,
      deletedCount: deletedCount
    };

  } catch (error) {
    console.error('Temizleme hatası:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Token bilgisini getir (debug için)
 */
export const getVerificationInfo = async (token) => {
  try {
    const verificationRef = doc(verificationCollection, token);
    const verificationSnap = await getDoc(verificationRef);

    if (!verificationSnap.exists()) {
      return {
        success: false,
        message: 'Token bulunamadı'
      };
    }

    const data = verificationSnap.data();
    
    return {
      success: true,
      data: {
        email: data.email,
        name: data.name,
        verified: data.verified,
        attempts: data.attempts,
        expiresAt: data.expiresAt.toDate(),
        createdAt: data.createdAt?.toDate()
      }
    };

  } catch (error) {
    console.error('Bilgi getirme hatası:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export default {
  createVerificationCode,
  verifyCode,
  resendVerificationCode,
  cleanupExpiredVerifications,
  getVerificationInfo
};